var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6326_3642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6554 1.35571L11.2108 7.01411C10.5572 7.51051 9.48841 7.51051 8.83522 7.01411L1.39014 1.35571",
    stroke: "#0099CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.416 6.09912L18.6554 10.8411",
    stroke: "#0099CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.39014 10.8412L7.63081 6.09839",
    stroke: "#0099CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.575195 10.5C0.575195 11.0523 1.02291 11.5 1.5752 11.5H18.5752C19.1275 11.5 19.5752 11.0523 19.5752 10.5V1.5C19.5752 0.947715 19.1275 0.5 18.5752 0.5H1.57519C1.02291 0.5 0.575195 0.947715 0.575195 1.5V10.5Z",
    stroke: "#0099CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6326_3642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.2785,
    height: 12,
    fill: "white",
    transform: "translate(0.0751953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMail);
export default __webpack_public_path__ + "static/media/ico_mail.e618423f0ea473cdc721a61ddfd18058.svg";
export { ForwardRef as ReactComponent };